{
  "pages": {
    "hubTitle": "Chấm công",
    "listTitle": "Lịch sử chấm công",
    "monthlyTitle": "Bảng chấm công tháng",
    "clockTitle": "Chấm công",
    "detailsTitle": "Chi tiết chấm công",
    "editTitle": "Sửa chấm công",
    "recordTitle": "Ghi nhận chấm công thủ công",
    "permissionDenied": "Bạn không có quyền xem chấm công.",
    "clockPermissionDenied": "Bạn không có quyền chấm công.",
    "recordPermissionDenied": "Bạn không có quyền ghi nhận chấm công thủ công.",
    "tabs": {
      "team": "Bảng chấm công",
      "requests": "Yêu cầu chấm công"
    },
    "tabsAria": "Phần chấm công"
  },
  "views": {
    "label": "Chế độ xem",
    "list": "Danh sách",
    "month": "Bảng tháng",
    "summary": "Bảng tổng hợp"
  },
  "summary": {
    "clinicRequired": "Chọn phòng khám để xem bảng tổng hợp.",
    "sameMonthRequired": "Chọn khoảng ngày trong cùng một tháng để xem tổng hợp.",
    "empty": "Không có nhân viên thuộc phòng khám này.",
    "scheduledDays": "Công chuẩn",
    "presentDays": "Đi làm",
    "absentDays": "Vắng",
    "lateDays": "Ngày trễ",
    "lateMinutes": "Phút trễ",
    "earlyLeaveDays": "Ngày về sớm",
    "earlyLeaveMinutes": "Phút về sớm"
  },
  "monthly": {
    "month": "Tháng",
    "clinicRequired": "Chọn phòng khám để xem bảng tháng.",
    "empty": "Không có nhân viên thuộc phòng khám này.",
    "payableHint": "Ngày công = có mặt, hoặc nghỉ all-day hưởng lương. Tăng ca (phút) chỉ đối chiếu — chưa trả lương. Khóa tháng trước khi tính lương ngày.",
    "lockedHint": "Bảng công tháng đã khóa (ngày công + phút tăng ca). Sửa chấm công khi mở khóa — kỳ lương đã duyệt/khóa không đổi.",
    "lockedBadge": "Đã khóa công",
    "lock": "Khóa tháng",
    "locking": "Đang khóa…",
    "unlock": "Mở khóa",
    "unlocking": "Đang mở khóa…",
    "unlockTitle": "Mở khóa bảng công tháng",
    "unlockHint": "Chỉ mở khóa khi kỳ lương tháng này chưa duyệt/khóa. Cần lý do.",
    "unlockReason": "Lý do mở khóa",
    "lockSuccess": "Đã khóa bảng công tháng",
    "unlockSuccess": "Đã mở khóa bảng công",
    "lockFailed": "Không khóa được bảng công",
    "incompleteLockError": "Còn {{count}} bản ghi thiếu giờ vào hoặc ra. Bổ sung trước khi khóa tháng.",
    "incompleteTitle": "Chưa khóa được — thiếu chấm công",
    "incompleteHint": "Sửa tay, gửi yêu cầu chấm, hoặc đánh vắng các ngày sau rồi khóa lại.",
    "incompleteMissingIn": "Thiếu giờ vào",
    "incompleteMissingOut": "Thiếu giờ ra",
    "incompleteMissingBoth": "Thiếu vào và ra",
    "unlockFailed": "Không mở khóa được bảng công",
    "payableDaysCount": "{{count}} công",
    "overtimeMinutesCount": "OT {{count}} phút",
    "legend": "● có mặt · T đi trễ · S về sớm · V vắng · ○ chưa ra ca — bấm ô để xem chi tiết",
    "clickHint": "Bấm ô để xem chi tiết",
    "cell": {
      "empty": "—",
      "fullDay": "Đủ công",
      "late": "Đi trễ {{minutes}}'",
      "earlyLeave": "Về sớm {{minutes}}'",
      "lateAndEarly": "Trễ & về sớm",
      "leave": "Nghỉ phép",
      "absent": "Vắng mặt",
      "missingCheckout": "Thiếu chấm ra",
      "workedHours": "{{hours}} giờ tính công",
      "overtime": "+{{minutes}}' OT"
    },
    "badge": {
      "absent": "Vắng",
      "late": "Trễ",
      "early": "Sớm",
      "pending": "Chưa ra",
      "leave": "Nghỉ phép"
    }
  },
  "clock": {
    "statusNotStarted": "Chưa vào ca hôm nay",
    "statusOpen": "Đang trong ca — bạn đã vào ca",
    "statusCompleted": "Đã ra ca hôm nay",
    "subtitle": "Chấm vào / ra ca cho tài khoản đang đăng nhập",
    "todaySummary": "Ca hôm nay",
    "noRecordYet": "Chưa có bản ghi hôm nay",
    "summaryUnavailable": "Không tải được tóm tắt ca hôm nay",
    "methodDisabled": "Phòng khám chưa bật phương thức chấm công. Liên hệ quản lý."
  },
  "fields": {
    "staff": "Nhân viên",
    "department": "Bộ phận",
    "date": "Ngày",
    "workDate": "Ngày làm việc",
    "clockIn": "Vào ca",
    "clockOut": "Ra ca",
    "clockInOut": "Vào / Ra ca",
    "clockInTime": "Giờ vào ca",
    "clockOutTime": "Giờ ra ca",
    "workedDuration": "Thời gian",
    "workedTime": "Thời gian làm",
    "status": "Trạng thái",
    "source": "Nguồn",
    "notes": "Ghi chú",
    "clockInLocation": "Vị trí vào ca",
    "clockOutLocation": "Vị trí ra ca",
    "clockInNetwork": "Mạng vào ca",
    "clockOutNetwork": "Mạng ra ca",
    "clockInAccuracy": "Độ chính xác vào ca",
    "clockOutAccuracy": "Độ chính xác ra ca",
    "clockInCapturedAt": "Lấy vị trí vào ca",
    "clockOutCapturedAt": "Lấy vị trí ra ca",
    "clockInDistance": "Khoảng cách vào ca",
    "clockOutDistance": "Khoảng cách ra ca",
    "clockInGeofence": "Vùng chấm vào ca",
    "clockOutGeofence": "Vùng chấm ra ca",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "fromDate": "Từ ngày",
    "toDate": "Đến ngày",
    "clinic": "Phòng khám"
  },
  "actions": {
    "recordManually": "Chấm công",
    "clockIn": "Vào ca",
    "clockOut": "Ra ca",
    "goToClock": "Chấm công",
    "moreActions": "Thêm hành động",
    "viewHistory": "Lịch sử chấm công",
    "viewDetails": "Chi tiết",
    "back": "Quay lại",
    "saveChanges": "Lưu thay đổi",
    "saving": "Đang lưu..."
  },
  "filters": {
    "all": "Tất cả",
    "trigger": "Bộ lọc",
    "title": "Lọc chấm công",
    "requestsTitle": "Lọc yêu cầu",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng ngày",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectStatus": "Chọn trạng thái",
    "selectPunctuality": "Chọn chuyên cần",
    "selectSource": "Chọn nguồn",
    "selectClinic": "Chọn phòng khám",
    "searchPlaceholder": "Tìm theo tên hoặc mã nhân viên...",
    "allStatuses": "Tất cả trạng thái",
    "checkoutPending": "Chưa ra ca",
    "allPunctuality": "Tất cả chuyên cần",
    "allSources": "Tất cả nguồn",
    "allStaff": "Tất cả nhân viên",
    "allClinics": "Tất cả phòng khám"
  },
  "status": {
    "auto": "Tự động (theo giờ vào/ra)",
    "present": "Có mặt",
    "absent": "Vắng mặt",
    "checkoutPending": "Chưa ra ca"
  },
  "punctuality": {
    "on_time": "Đúng giờ",
    "late": "Đi trễ",
    "early_leave": "Về sớm",
    "late_and_early": "Trễ & về sớm",
    "not_scheduled": "Không có ca",
    "excused": "Được miễn (nghỉ)",
    "incomplete": "Chưa đủ giờ",
    "field": "Chuyên cần",
    "planned": "Giờ kế hoạch",
    "overtime": "Tăng ca",
    "lateMinutes": "Muộn {{count}} phút",
    "earlyLeaveMinutes": "Về sớm {{count}} phút",
    "overtimeMinutes": "Tăng ca {{count}} phút",
    "clockInLateToast": "Bạn vào ca muộn {{count}} phút so với lịch"
  },
  "sources": {
    "gps": "Tự chấm GPS",
    "self": "Tự chấm",
    "manual": "Nhập tay",
    "wifi": "Wi‑Fi"
  },
  "wifi": {
    "clockHint": "Chấm qua Wi‑Fi",
    "notOnNetwork": "Không trên mạng đã cấu hình. IP hiện tại: {{ip}}"
  },
  "today": "Hôm nay ({{date}})",
  "gps": {
    "requirement": "Tự chấm công yêu cầu GPS và phải ở trong phạm vi chi nhánh.",
    "manualHint": " Ghi nhận hoặc chỉnh sửa thủ công dùng nút \"Chấm công thủ công\".",
    "locatingTitle": "Đang lấy vị trí GPS",
    "locatingMessage": "Vui lòng cho phép truy cập vị trí và đợi trong giây lát...",
    "noData": "Chưa có dữ liệu GPS",
    "distanceFromClinic": "Cách chi nhánh {{distance}}m",
    "insideGeofence": "Trong vùng",
    "outsideGeofence": "Ngoài vùng",
    "viewOnMap": "Xem trên bản đồ",
    "outsideGeofenceError": "Bạn đang cách {{clinic}} {{distance}}m. Cần trong phạm vi {{radius}}m.",
    "defaultClinic": "chi nhánh",
    "accuracyTooLow": "Tín hiệu GPS không ổn định ({{accuracy}}m). Tối đa cho phép {{maxAccuracy}}m.",
    "clinicCoordinatesMissing": "Chi nhánh chưa cấu hình tọa độ GPS. Liên hệ quản trị.",
    "required": "Cần bật GPS để chấm công."
  },
  "table": {
    "empty": "Chưa có bản ghi chấm công"
  },
  "placeholders": {
    "manualReason": "Ví dụ: Quên chấm, GPS lỗi",
    "selectStaff": "Chọn nhân viên"
  },
  "validation": {
    "selectStaff": "Vui lòng chọn nhân viên",
    "dateRequired": "Vui lòng chọn ngày",
    "clockOutAfterClockIn": "Giờ ra ca phải sau giờ vào ca",
    "notesTooLong": "Ghi chú không được quá {{max}} ký tự"
  },
  "details": {
    "noRecord": "Không có bản ghi."
  },
  "dialogs": {
    "confirmDelete": "Xóa bản ghi chấm công này?"
  },
  "toasts": {
    "loadListFailed": "Không thể tải danh sách chấm công",
    "loadRecordFailed": "Không thể tải bản ghi chấm công",
    "loadStaffFailed": "Không thể tải danh sách nhân viên",
    "clockInSuccess": "Chấm công vào ca thành công",
    "clockOutSuccess": "Chấm công ra ca thành công",
    "clockInFailed": "Chấm công vào ca thất bại",
    "clockOutFailed": "Chấm công ra ca thất bại",
    "recordSuccess": "Ghi nhận chấm công thành công",
    "recordFailed": "Ghi nhận chấm công thất bại",
    "updateSuccess": "Cập nhật thành công",
    "updateFailed": "Cập nhật thất bại",
    "deleteSuccess": "Đã xóa bản ghi",
    "deleteFailed": "Xóa bản ghi thất bại"
  },
  "errors": {
    "ATTENDANCE_MONTH_LOCKED": "Bảng công tháng đã khóa, không sửa chấm công được.",
    "ATTENDANCE_MONTH_NOT_LOCKED": "Bảng công tháng chưa khóa.",
    "ATTENDANCE_MONTH_IN_PAYROLL": "Kỳ lương tháng này đã duyệt hoặc khóa, không mở khóa bảng công được.",
    "UNLOCK_REASON_REQUIRED": "Nhập lý do mở khóa.",
    "INVALID_MONTH": "Tháng phải dạng YYYY-MM.",
    "ATTENDANCE_APPROVER_REQUIRED": "Chưa có người duyệt chấm công. Cấu hình trên hồ sơ nhân viên hoặc phòng ban trước khi gửi.",
    "NOT_ATTENDANCE_APPROVER": "Bạn không phải người duyệt của yêu cầu này.",
    "ATTENDANCE_INCOMPLETE_CLOCKS": "Còn bản ghi thiếu giờ vào hoặc ra. Bổ sung trước khi khóa tháng."
  },
  "duration": {
    "minutes": "{{count}} phút",
    "hoursMinutes": "{{hours}}h {{minutes}}p"
  },
  "requests": {
    "listTitle": "Yêu cầu chấm công",
    "createTitle": "Tạo yêu cầu chấm công",
    "detailsTitle": "Chi tiết yêu cầu chấm công",
    "empty": "Chưa có yêu cầu chấm công",
    "searchPlaceholder": "Tìm theo tên, mã nhân viên hoặc lý do...",
    "fields": {
      "requester": "Người yêu cầu",
      "clockDate": "Ngày chấm công",
      "requestedTimes": "Giờ chấm công",
      "requestedStatus": "Trạng thái chấm công",
      "requestedStatusHint": "Chỉ ghi vào bảng công sau khi yêu cầu được duyệt.",
      "reason": "Lý do",
      "rejectionReason": "Lý do từ chối",
      "approvers": "Người duyệt",
      "reviewedBy": "Người xử lý",
      "reviewedAt": "Ngày xử lý",
      "attachments": "Tệp đính kèm"
    },
    "approversEmpty": "Chưa có người duyệt",
    "approversHelper": "Cấu hình người duyệt chấm công trên hồ sơ nhân viên hoặc phòng ban. Không có người duyệt thì không gửi được yêu cầu.",
    "approversSetup": "Thiết lập trên hồ sơ nhân viên",
    "approversSetupReadonly": "Liên hệ quản trị viên để gán người duyệt trên hồ sơ hoặc phòng ban.",
    "attachmentsHint": "Ảnh, PDF hoặc tài liệu Office, tối đa 10 tệp, mỗi tệp 10MB.",
    "placeholders": {
      "reason": "Ví dụ: quên chấm công, GPS lỗi..."
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Từ chối",
      "cancelled": "Đã hủy"
    },
    "actions": {
      "create": "Tạo yêu cầu",
      "submit": "Gửi yêu cầu",
      "review": "Xem để duyệt",
      "view": "Xem",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "cancel": "Hủy yêu cầu"
    },
    "validation": {
      "required": "Vui lòng nhập đủ nhân viên, ngày và lý do",
      "reasonRequired": "Vui lòng nhập lý do"
    },
    "dialogs": {
      "approveTitle": "Duyệt yêu cầu",
      "approveBody": "Bản ghi chấm công sẽ được tạo hoặc cập nhật theo nội dung yêu cầu.",
      "rejectTitle": "Từ chối yêu cầu",
      "cancelTitle": "Hủy yêu cầu",
      "cancelBody": "Bạn có chắc muốn hủy yêu cầu đang chờ duyệt?"
    },
    "toasts": {
      "loadFailed": "Không thể tải yêu cầu chấm công",
      "createSuccess": "Đã gửi yêu cầu chấm công",
      "createFailed": "Không thể tạo yêu cầu chấm công",
      "approveSuccess": "Đã duyệt yêu cầu",
      "approveFailed": "Không thể duyệt yêu cầu",
      "rejectSuccess": "Đã từ chối yêu cầu",
      "rejectFailed": "Không thể từ chối yêu cầu",
      "cancelSuccess": "Đã hủy yêu cầu",
      "cancelFailed": "Không thể hủy yêu cầu",
      "actionFailed": "Không thể cập nhật yêu cầu"
    }
  },
  "rejectionReason": "Lý do từ chối",
  "absence": {
    "action": "Đánh dấu vắng",
    "title": "Đánh dấu vắng theo lịch làm",
    "result": "Đã tạo {{created}} bản ghi, bỏ qua {{skipped}} nhân viên",
    "failed": "Không thể đánh dấu vắng"
  },
  "bulk": {
    "action": "Ghi hàng loạt",
    "title": "Ghi nhận chấm công hàng loạt",
    "staff": "Nhân viên",
    "selectStaff": "Chọn nhân viên",
    "absent": "Vắng mặt",
    "present": "Có mặt",
    "overwrite": "Ghi đè bản ghi đã có",
    "submit": "Áp dụng",
    "apply": "Áp dụng",
    "required": "Vui lòng chọn ngày và ít nhất một nhân viên",
    "toasts": {
      "success": "Đã tạo {{created}}, cập nhật {{updated}}, bỏ qua {{skipped}}",
      "failed": "Không thể ghi nhận chấm công hàng loạt"
    },
    "result": "Đã tạo {{created}}, cập nhật {{updated}}, bỏ qua {{skipped}}",
    "failed": "Không thể ghi nhận chấm công hàng loạt"
  }
}
